<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <basic-info-relatorio
              id="basic-info-relatorio"
              ref="basicInfo"
              :consulta="consulta"
              @baseDeDadosChange="baseDeDadosUpdate"
            />
          </v-col>
        </v-row>
        <div>
          <v-row id="row-campos" class="mt-n5" :class="esmaecerPagina">
            <v-col cols="12" md="6">
              <campos-relatorio
                id="campos-relatorio"
                ref="camposRelatorios"
                :items="fieldsLinhas"
                :consulta="consulta"
                style="min-height: 250px"
              />
            </v-col>
            <v-col cols="12" md="6">
              <campos-valores
                id="campos-valores"
                ref="camposValores"
                :items="fieldsValores"
                :consulta="consulta"
                style="min-height: 250px"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <div>
          <v-row id="row-filtros" class="mt-n10" :class="esmaecerPagina">
            <v-col cols="12" md="12">
              <campos-filtros
                id="campos-filtros"
                ref="camposFiltros"
                :items="fields"
                :view="baseDeDados"
                :consulta="consulta"
                style="min-height: 100px"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row id="row-btn-save" :class="esmaecerPagina">
      <v-col cols="12" md="6" />
      <v-col cols="12" md="6">
        <v-btn
          id="btn-save-relatorio"
          color="green"
          min-width="100"
          style="float: right;"
          class="mt-n5"
          :loading="loading"
          @click="postEditRelatorio"
        >
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TabelasService from "@/services/TabelasService.js";
import RelatoriosService from "@/services/RelatoriosService.js";
import tourMixins from "@/mixins/tourMixins";

export default {
  name: "EditRelatorios",

  components: {
    BasicInfoRelatorio: () =>
      import("@/components/relatorios/BasicInfoRelatorio"),
    CamposRelatorio: () => import("@/components/relatorios/CamposRelatorio"),
    CamposValores: () => import("@/components/relatorios/CamposValores"),
    CamposFiltros: () => import("@/components/relatorios/CamposFiltros"),
  },

  mixins: [tourMixins],

  data() {
    return {
      loading: false,
      baseDeDados: "",
      fields: [],
      fieldsLinhas: [],
      fieldsValores: [],
      consulta: {},
      arrTour: [
        {
          element: "#basic-info-relatorio",
          intro:
            "Aqui você poderá escolher um nome para seu relatório e selecionar a base de dados desejada.",
          scrollTo: "tooltip",
          position: "right",
        },
        {
          element: "#campos-relatorio",
          intro:
            "Aqui você poderá selecionar os campos da base que irão compor o relatório.",
          scrollTo: "tooltip",
          position: "right",
        },
        {
          element: "#campos-valores",
          intro: `Aqui você poderá selecionar os campos de valores que irão compor o relatório.<br><br>
            Obs: É possivel também realizar operações nos valores e/ou datas.
            `,
          scrollTo: "tooltip",
          position: "left",
        },
        {
          element: "#campos-filtros",
          intro:
            "Aqui você poderá adicionar filtros para processamento de seu relatório.",
          scrollTo: "tooltip",
          position: "top",
        },
        {
          element: "#btn-hint-valores",
          intro:
            "Aqui você poderá consultar por dicas de valores de acordo com o campo selecionado.",
          scrollTo: "tooltip",
          position: "top",
        },
        {
          element: "#btn-add-remove-filtro",
          intro:
            "Aqui você poderá adicionar ou remover filtros de seu relatório.",
          scrollTo: "tooltip",
          position: "top",
        },
        {
          element: "#btn-save-relatorio",
          intro:
            "Após seleção dos critérios anteriores clique aqui para salvar e executar o relatório.",
          scrollTo: "tooltip",
          position: "left",
        },
      ],
      /* Caso algum campo considerado valor (decimal) tenha que ser definido como campos de linhas, basta inserir o nome nesse objeto */
      forceCamposToLinhas: {
        view_razao: [
          "PERCENTUAL_OE",
          "VALOR_DOACAO",
          "VALOR_INCORPORACAO",
          "VALOR_OBRA",
          "VALOR_OBRA_AIC",
          "FATOR_CONVERSAO_MCPSE",
          "TENSAO",
        ],
        view_razao_consulta: [
          "PERCENTUAL_OE",
          "VALOR_DOACAO",
          "VALOR_INCORPORACAO",
          "VALOR_OBRA",
          "VALOR_OBRA_AIC",
          "FATOR_CONVERSAO_MCPSE",
          "TENSAO",
        ],
        view_registros_ais: [
          "IA_ODI",
          "TAXA_ANUAL_DEP_ATE_DEZEMBRO_2011",
          "TAXA_ANUAL_DEP_APOS_DEZEMBRO_2011",
        ],
        view_banco_precos: [
          "ALIQUOTA_ICMS",
          "ALIQUOTA_IPI",
          "ALIQUOTA_ICMS_DIF",
          "ODC_CONSOLIDADA",
          "Tx_SISCOMEX",
          "TX_DEMURRAGE",
          "TAXA_CAMBIO",
          "TX_CB_DI",
        ],
        view_georreferenciado: ["FATOR_CONVERSAO_MCPSE"],
      },
    };
  },

  computed: {
    esmaecerPagina() {
      return this.baseDeDados == "" ? "esmaecer esmaecer-aux" : "";
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.getConsulta(this.$route.params.id);
    }
    this.iniciarTourPagina();
  },

  methods: {
    getConsulta(id) {
      RelatoriosService.getRelatorioConsulta(id)
        .then((response) => {
          this.consulta = response.data.consulta;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Erro ao recuperar relatório.", "", {
            position: "topRight",
          });
        });
    },

    baseDeDadosUpdate(value) {
      TabelasService.getViewsCampos(value)
        .then((response) => {
          this.baseDeDados = value;

          let arrayAux = response.data.colunas.map((e) => {
            return {
              text: e.field,
              type: e.type,
              key: Math.ceil(Math.random() * 1000000),
            };
          });
          this.fields = arrayAux;
          let forceCamposToLinhas = this.forceCamposToLinhas[value] || [];

          this.fieldsLinhas = this.fields.filter(function(e) {
            return (
              (e.type != "decimal" || forceCamposToLinhas.includes(e.text)) &&
              e.text != "Contador" &&
              !e.text.includes("ANO")
            );
          });
          this.fieldsValores = this.fields.filter(function(e) {
            return (
              (e.type == "decimal" && !forceCamposToLinhas.includes(e.text)) ||
              e.type == "date" ||
              e.type == "datetime" ||
              e.text == "Contador" ||
              e.text.includes("ANO")
            );
          });
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Erro ao recuperar bases de dados.", "", {
            position: "topRight",
          });
        });
    },

    postEditRelatorio() {
      let data = [];

      data["basic"] = this.$refs.basicInfo.exportCampos();
      data["campos"] = this.$refs.camposRelatorios.exportCampos();
      data["valores"] = this.$refs.camposValores.exportCampos();
      data["filtros"] = this.$refs.camposFiltros.exportCampos();

      if (data["filtros"] == "invalido") {
        return;
      }

      this.loading = true;

      if (data["basic"].nome == "" || data["basic"].view == "") {
        this.$toast.warning("Preencha as informações básicas.", "", {
          position: "topRight",
        });
        this.loading = false;
        return;
      }

      if (data["campos"].length == 0 && data["valores"].length == 0) {
        this.$toast.warning("Selecione pelo menos um campo.", "", {
          position: "topRight",
        });
        this.loading = false;
        return;
      }

      if (!this.validaCamposValores(data["valores"])) {
        this.$toast.warning(
          "Não selecione mais de um campo valor com a mesma função.",
          "",
          { position: "topRight" }
        );
        this.loading = false;
        return;
      }

      data["valores"] = this.filtraCamposValores(
        data["campos"],
        data["valores"]
      );

      this.$toast.info("Salvando relatório...", "", { position: "topRight" });

      const idRelatorio = this.$route.params.id ? this.$route.params.id : null;

      const userUid = this.$store.getters.getUserUid;
      RelatoriosService.postRelatorio(data, idRelatorio, userUid)
        .then((response) => {
          this.$toast.success("Relatório salvo com sucesso.", "", {
            position: "topRight",
          });
          this.$router.push({ name: "Relatórios Histórico" });
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Erro ao salvar.", "", { position: "topRight" });
        })
        .finally(() => (this.loading = false));
    },

    /*** Function para remover duplicatas entre Campos Linha e Campos Valores */
    filtraCamposValores(campos, valores) {
      return valores.filter((valor) =>
        valor.hasOwnProperty("function")
          ? true
          : !campos.some((campo) => campo.text == valor.text)
      );
    },

    validaCamposValores(campos) {
      let camposAux = JSON.parse(JSON.stringify(campos));
      let isInvalid = false;

      for (let i in campos) {
        camposAux.shift();

        isInvalid = camposAux.some(
          (campoAux) =>
            campoAux.text === campos[i].text &&
            campoAux.function === campos[i].function
        );

        if (isInvalid) return false;
      }

      if (!isInvalid) return true;
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;

      let onBeforeChangeFunction = {
        func: () => {
          let elementsEsmaecidos = document.querySelectorAll(
            "#row-campos, #row-filtros, #row-btn-save"
          );
          elementsEsmaecidos.forEach((element) => {
            element.classList.remove("esmaecer");
          });
        },
        runInStep: 1,
      };

      let onBeforeExitFunction = {
        func: () => {
          let elementsEsmaecidos = document.querySelectorAll(
            "#row-campos, #row-filtros, #row-btn-save"
          );
          elementsEsmaecidos.forEach((element) => {
            if (!this.$route.params.id) element.classList.add("esmaecer");
          });
        },
      };

      this.iniciarTour(
        this.arrTour,
        [],
        [onBeforeChangeFunction],
        [onBeforeExitFunction]
      );
    },
  },
};
</script>

<style scoped>
.esmaecer {
  pointer-events: none;
  opacity: 0.4;
}
</style>
